import { gql } from '@apollo/client';

/**
 * 「派件妥投汇总分页」DSP 经理版本。
 * 与 GET_DISPATCH_DELIVERY_SUMMARY_PAGE 字段结构一致，仅后端入口方法不同。
 * 使用 GraphQL 别名 `getDispatchDeliverySummaryPage: getDispatchDeliverySummaryPageForDspManager`
 * 让响应字段名保持一致，下游可直接复用 DispatchDeliverySummaryPageResponse 类型。
 */
export const GET_DISPATCH_DELIVERY_SUMMARY_PAGE_FOR_DSP_MANAGER = gql`
    query GetDispatchDeliverySummaryPageForDspManager($filter: DispatchDeliverySummaryFilterInput!, $pageRequest: DispatchDeliverySummaryPageRequestInput) {
        getDispatchDeliverySummaryPage: getDispatchDeliverySummaryPageForDspManager(filter: $filter, pageRequest: $pageRequest) {
            items {
                id
                hubId
                dspId
                dspName
                warehouseId
                warehouseName
                statDate
                statWeek
                statMonth
                actualArrivalsCount
                t0DeliveredCount
                t1DeliveredCount
                t2DeliveredCount
                t3DeliveredCount
                t0DeliveredRate
                t1DeliveredRate
                t2DeliveredRate
                t3DeliveredRate
                calculatedAt
                weekDateRange
                isIncompleteWeek
                monthDateRange
                isIncompleteMonth
            }
            page
            size
            total
            isDataCalculated
        }
    }
`;
